import { gql } from '@apollo/client'
import { SABRE_SIMPLE_PRODUCT_FRAGMENT } from '../fragments/SimpleProductFragment'

export const SABRE_GET_SIMPLE_PRODUCTS = gql`
  query GetSimpleProducts($input: ProductsInput) {
    products(input: $input) {
      count
      hasMore
      results {
        ...SimpleProduct
      }
    }
  }
  ${SABRE_SIMPLE_PRODUCT_FRAGMENT}
`
